import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AdminStatCard = ({
  title,
  value,
  icon,
  iconBg,
  change,
  changeType = 'increase',
  linkTo,
  linkText = 'View All'
}) => {
  // Default color is primary/accent color
  const bgColor = iconBg || 'var(--dark-accent)';
  
  const renderChangeIndicator = () => {
    if (change === undefined || change === null) return null;
    
    const isPositive = changeType === 'increase' && change > 0;
    const isNegative = changeType === 'decrease' && change > 0;
    const iconClass = isPositive || isNegative ? 'fa-arrow-up' : 'fa-arrow-down';
    const colorClass = isPositive || isNegative ? 'text-success' : 'text-danger';
    
    return (
      <span className={`ms-2 ${colorClass}`}>
        <i className={`fa ${iconClass} small`}></i> {Math.abs(change)}%
      </span>
    );
  };

  return (
    <div className="stat-card card">
      <div className="card-body">
        <div className="d-flex align-items-center mb-3">
          <div 
            className="stat-icon-wrapper me-3 d-flex justify-content-center align-items-center"
            style={{ 
              backgroundColor: bgColor,
              width: '48px',
              height: '48px',
              borderRadius: '12px'
            }}
          >
            <i className={`fa ${icon} text-white fs-5`}></i>
          </div>
          <div>
            <h6 className="stat-title text-secondary mb-0">{title}</h6>
            <h3 className="stat-value mb-0">{value}</h3>
          </div>
        </div>
        
        <div className="d-flex justify-content-between align-items-center">
          <div className="stat-change">
            {renderChangeIndicator()}
            <span className="text-muted ms-1 small">vs last month</span>
          </div>
          {linkTo && (
            <Link to={linkTo} className="btn btn-link btn-sm p-0 text-primary">
              {linkText}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

AdminStatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.string.isRequired,
  iconBg: PropTypes.string,
  change: PropTypes.number,
  changeType: PropTypes.oneOf(['increase', 'decrease']),
  linkTo: PropTypes.string,
  linkText: PropTypes.string
};

export default AdminStatCard;
